import * as Yup from "yup";

export const totalStudentValidation = Yup.object().shape({
  value: Yup.string().required("وارد کردن تعداد الزامی است"),
});
